import { bootToolPage } from '../lib/boot-tool'
import { openStage } from '../lib/stage'
import { stageMarkup } from '../lib/stage-html'
import { t } from '../i18n/dictionaries'

const locale = bootToolPage('grid')
document.body.insertAdjacentHTML(
  'beforeend',
  stageMarkup({ controls: ['exit', 'prev', 'next', 'hide'] }),
)
document.querySelectorAll<HTMLElement>('[data-stage-root] [data-i18n]').forEach((node) => {
  const key = node.dataset.i18n
  if (key) node.textContent = t(locale, key)
})

let mode: 'grid' | 'checker' = 'grid'

document.querySelector('[data-action="start"]')?.addEventListener('click', () => {
  const stage = document.querySelector<HTMLElement>('[data-stage-root]')
  const canvas = document.querySelector<HTMLElement>('[data-stage-canvas]')
  const sizeInput = document.querySelector<HTMLInputElement>('#grid-size')
  if (!stage || !canvas) return

  const paint = () => {
    const size = Number(sizeInput?.value || 24)
    if (mode === 'grid') {
      canvas.style.backgroundColor = '#111'
      canvas.style.backgroundImage = `
        linear-gradient(#3ddc97 1px, transparent 1px),
        linear-gradient(90deg, #3ddc97 1px, transparent 1px)`
      canvas.style.backgroundSize = `${size}px ${size}px`
    } else {
      canvas.style.backgroundColor = '#000'
      canvas.style.backgroundImage = `
        linear-gradient(45deg, #fff 25%, transparent 25%),
        linear-gradient(-45deg, #fff 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #fff 75%),
        linear-gradient(-45deg, transparent 75%, #fff 75%)`
      canvas.style.backgroundSize = `${size * 2}px ${size * 2}px`
      canvas.style.backgroundPosition = `0 0, 0 ${size}px, ${size}px -${size}px, -${size}px 0`
    }
    const label = stage.querySelector('[data-stage-label]')
    if (label) label.textContent = `${mode} · ${size}px`
  }

  const close = openStage(stage, {
    onExit: () => {
      close()
    },
    onPrev: () => {
      mode = mode === 'grid' ? 'checker' : 'grid'
      paint()
    },
    onNext: () => {
      mode = mode === 'grid' ? 'checker' : 'grid'
      paint()
    },
  })
  sizeInput?.addEventListener('input', paint)
  paint()
})
